import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "rec-selector-menu__break"
};
const _hoisted_2 = { class: "rec-selector-menu__group-header" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectorOptionHeader',
    props: {
        header: {},
        breakRequired: { type: Boolean }
    },
    setup(__props) {
        // Types & Enums
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.breakRequired)
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.header.header), 1)
            ], 64));
        };
    }
});
